import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppMaterialModule } from './app-material/app-material.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';


import { AppComponent } from './app.component';
import { MessageComponent } from './message/message.component';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { ActivateComponent } from './activate/activate.component';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { JwtInterceptor } from './_helpers/jwt.interceptor';
import { ErrorInterceptor } from './_helpers/error.interceptor';
import { routing } from './app.routing';
import { AppConfig } from './app.config';
import { AppNavbarComponent } from './shared/app-navbar/app-navbar.component';
import { InvoiceModule } from './invoice/invoice.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ItemModule } from './item/item.module';
import { CustomerModule } from './customer/customer.module';
import { NgxElectronModule } from 'ngx-electron';
import { NgxChildProcessModule } from 'ngx-childprocess';
import { SettingsModule } from './settings/settings.module';
import { ReportModule } from './report/report.module';
import { FileSaverModule } from 'ngx-filesaver';
import { QuillModule } from 'ngx-quill';
import { MessageBoxComponent } from './shared/message-box/message-box.component';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { MatPaginatorIntlCust } from './_helpers/mat-paginator-intl-cust';
import { MatPaginatorIntl } from '@angular/material';

@NgModule({
  declarations: [
    AppComponent,
    MessageComponent,
    ActivateComponent,
    LoginComponent,
    HomeComponent,
    AppNavbarComponent,
    MessageBoxComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule, BrowserAnimationsModule,
    AppMaterialModule,
    ReactiveFormsModule,
    FormsModule,
    routing,
    InvoiceModule,
    ItemModule,
    CustomerModule,
    ReportModule,
    SettingsModule,
    FlexLayoutModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    NgxElectronModule,
    NgxChildProcessModule,
    FileSaverModule,
    NgxDaterangepickerMd.forRoot(),
    NgxChartsModule
  ],
  providers: [AppConfig,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppConfig], multi: true
    },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: MatPaginatorIntl, useClass: MatPaginatorIntlCust }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }


// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/');
}

export function initializeApp(appConfig: AppConfig) {
  return () => appConfig.load();
}
